// Services
import FirebaseStorageService from '../services/storageService'

export const uploadPicture = async (file: File | Blob, path: string, fileName?: string) => {
  try {
    const downloadUrl = await FirebaseStorageService.uploadFile(
      file,
      `${path}/${fileName || new Date().getTime()}`
    )

    return `${downloadUrl || ''}`
  } catch (e) {
    console.error(e)
  }
}
